/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.users.assign.controllers', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.directive.cellInput',
  'acme.common.factory.notice'
])

.controller('UsersAssignController', ['$scope', '$uibModal', 'ApiService', 'HelpersService', 'NoticeFactory', function($scope, $uibModal, ApiService, HelpersService, NoticeFactory) {

    $scope.gridLink = '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ui-sref="application.users.detail({ id: {{ row.entity.id }} })" role="link">{{grid.getCellValue(row, col)}}</a></div>';

    $scope.usersAssign = {

      isUpdated: true,

      resourcesSummaries: [],
      resourceTemplates: [],
      selectedAssignedUsers: [],
      selectedUnassignedUsers: [],
      editedAssignedUsers: [],

      search: {},

      model: {},
      usersModel: {},
      assignedUsersModel: {},
      unassignedUsersModel: {},

      sortInfo: {
        columns: [],
        fields: [],
        directions: ['asc', 'desc']
      },
      multiSelectModal: {},

      selectedResourceTemplateId: '',

      defaultAssignmentColumns: [
        {
          field: 'firstName',
          displayName: 'FirstName',
          enableCellEdit: false
        },
        {
          field: 'lastName',
          displayName: 'Last Name',
          enableCellEdit: false
        }
      ],

      updateCache: [],
      assignmentFields: [],
      assignmentColumns: [],

      init: function() {
        $scope.$emit('Application::viewChange', { view: 'full' });

        $scope.$on('cellInputEdit', this.onCellInputEdit);
        $scope.$on('cellInputEditStart::modal', this.cellInputEditStartModal);

        $scope.$watch('usersAssign.sortInfo.columns', function() {
          console.log('UsersAssignController -> $watch -> usersAssign.sortInfo.columns', arguments);

        });
        $scope.$watch('usersAssign.sortInfo.fields', function() {
          console.log('UsersAssignController -> $watch -> usersAssign.sortInfo.fields', arguments);
        });

        $scope.$on('ngGridEventEndCellEdit', function () {
          console.log('ngGridEventEndCellEdit', arguments);
          if ($scope.usersAssign.updateCache.length > 0) {
            $scope.usersAssign.isUpdated = false;
            $scope.$apply();
          }
        });
        $scope.$on('ngGridEventStartCellEdit', function () {});

        $scope.$on('$destroy', this.onDestroy);
        this.initResources();
        this.assignmentColumns = this.defaultAssignmentColumns.slice(0);
      },

      initResources: function(id) {
        this.selectedResourceTemplateId = id || false;
        ApiService.resource.list('Personnel')
          .then(this.initUsers)
          .then(this.initAssignedUsers)
          .then(this.initTemplates)
          .then(this.initResource);
      },

      initUsers: function(response) {
        $scope.usersAssign.resourcesSummaries = response.data.summaries;

        $scope.usersAssign.resourcesSummaries = $.each($scope.usersAssign.resourcesSummaries, function(index, value) {
          var selected;

          if (!$scope.usersAssign.selectedResourceTemplateId) {
            selected = (index === 0);
          }else{
            selected = ($scope.usersAssign.selectedResourceTemplateId === value.id);
          }

          if (selected) {
            value.selected = true;
            $scope.usersAssign.selectedResourceTemplateId = value.id;
          }else{
            value.selected = false;
          }
        });
        return ApiService.userProxy.list(HelpersService.getPaginator());
      },

      initAssignedUsers: function(response) {
        $scope.usersAssign.unassignedUsersModel = response.data.payload;
        $scope.usersAssign.usersModel = response.data.payload;
        return ApiService.resource.instances.list($scope.usersAssign.selectedResourceTemplateId);
      },

      initTemplates: function(response) {
        $scope.usersAssign.model = response.data.payload;
        $scope.usersAssign.assignedUsersModel = $scope.usersAssign.processUsers(response.data.payload);
        $scope.usersAssign.updateUnassignedUsers();
        return $scope.usersAssign.selectedResourceTemplateId;
      },

      initResource: function(id) {
        $scope.usersAssign.getResourceTemplate(id);
      },

      getUsers: function () {
        ApiService.userProxy.list(HelpersService.getPaginator()).then(this.success.getUsers, this.error.getUsers);
      },

      getAssignedUsers: function() {
        ApiService.resource.instances.list(this.selectedResourceTemplateId).then(this.success.getAssignedUsers, this.error.getAssignedUsers);
      },

      getUnassignedUsers: function() {
        //ApiService.resource.list(this.selectedResourceTemplateId);
      },

      getResourceTemplates: function (filter) {
        this.summariesLoading = true;
        ApiService.resource.list(filter).then(this.success.getResourceTemplates, this.error.getResourceTemplates);
      },

      getResourceTemplate: function(id) {
        if (!this.resourcesSummaries[id]) {
          ApiService.resource.detail(id).then(this.success.getResourceTemplate, this.error.getResourceTemplate);
        }
      },

      getResourceSummaries: function() {
        return $scope.usersAssign.resourcesSummaries;
      },

      updateField: function(index, id) {

      },

      processUsers: function(users) {

        var i, ii,
            j, jj,
            rowUser = {},
            processed = [];

        for (i=0,ii=users.length;i<ii;i++) {
          rowUser = {
            id: users[i].ownerId,
            firstName: users[i].resourceUser.userFirstName,
            lastName: users[i].resourceUser.userLastName
          };

          if (users[i].fields instanceof Array) {
            for (j=0,jj=users[i].fields.length;j<jj;j++) {
              rowUser['id_' + users[i].fields[j].fieldOrder] = HelpersService.getFieldValue(users[i].fields[j]);
              console.log('UsersAssignController::processUsers -> rowUser', rowUser['id_' + users[i].fields[j].fieldOrder]);
            }
          }
          console.log('UsersAssignController::processUsers -> rowUser', rowUser);

          processed.push(rowUser);
        }

        console.log('UsersAssignController::processUsers', processed);
        return processed;
      },

      selectResource: function(resource) {
        this.initResources(resource.id);
      },

      updateAssignmentColumns: function(data) {

        var i, ii,
            j, jj,
            field,
            cellValue,
            fieldType,
            fieldValue,
            cellTemplate,
            editableCellTemplate;

        console.log('UsersAssignController::updateAssignmentColumns', data);

        this.assignmentColumns = this.defaultAssignmentColumns.slice(0);
        console.log('UsersAssignController::updateAssignmentColumns -> this.defaultAssignmentColumns', this.defaultAssignmentColumns);
        console.log('UsersAssignController::updateAssignmentColumns -> this.assignmentColumns', this.assignmentColumns);


        if (data.fields instanceof Array && data.fields.length > 0) {
          // Clear out preserved data
          this.editedAssignedUsers = [];

          for (j=0,jj=this.assignedUsersModel.length;j<jj;j++) {
            this.editedAssignedUsers.push({
              id: this.assignedUsersModel[j].id,
              firstName: this.assignedUsersModel[j].firstName,
              lastName: this.assignedUsersModel[j].lastName
            });
            for (i=0,ii=data.fields.length;i<ii;i++) {
              fieldValue = HelpersService.getFieldValue(data.fields[i]);
              fieldType = HelpersService.getFieldType(data.fields[i]);
              //console.log('UsersAssignController::unique', 'id_' + data.fields[i].fieldOrder, this.assignedUsersModel[j]);

              // Merge the template with the instance if it's an array value
              if (this.assignedUsersModel[j].hasOwnProperty('id_' + data.fields[i].fieldOrder)) {
                //console.log('UsersAssignController::updateAssignmentColumns -> hasValue', j, 'id_' + data.fields[i].fieldOrder, this.editedAssignedUsers[j]['id_' + data.fields[i].fieldOrder]);

                if (fieldType.type.indexOf('Array') > 0) {
                  console.log('UsersAssignController::unique');
                  this.editedAssignedUsers[j]['id_' + data.fields[i].fieldOrder] = this.assignedUsersModel[j]['id_' + data.fields[i].fieldOrder];
                  this.assignedUsersModel[j]['id_' + data.fields[i].fieldOrder] = HelpersService.unique(fieldValue, this.assignedUsersModel[j]['id_' + data.fields[i].fieldOrder]);
                }else if (!this.assignedUsersModel[j]['id_' + data.fields[i].fieldOrder]) {
                  this.assignedUsersModel[j]['id_' + data.fields[i].fieldOrder] = fieldValue;
                  this.editedAssignedUsers[j]['id_' + data.fields[i].fieldOrder] = fieldValue;
                }else{
                  this.editedAssignedUsers[j]['id_' + data.fields[i].fieldOrder] = this.assignedUsersModel[j]['id_' + data.fields[i].fieldOrder];
                  console.log('UsersAssignController::updateAssignmentColumns -> hasValue', j, 'id_' + data.fields[i].fieldOrder, this.editedAssignedUsers[j]['id_' + data.fields[i].fieldOrder]);
                }
              }

            }
          }

          console.log('UsersAssignController::unique', this.assignedUsersModel);


          // Clear out assignment field columns
          this.assignmentFields = [];
          //this.sortInfo.fields = [];

          for (i=0,ii=data.fields.length;i<ii;i++) {
            cellValue = HelpersService.getFieldValue(data.fields[i]);
            field = HelpersService.low(HelpersService.getFieldType(data.fields[i]).type);
            console.log('UsersAssignController::updateAssignmentColumns', cellValue);

            cellTemplate = '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a>{{ COL_FIELD }}<span data-ng-if="!COL_FIELD">Select One</a></div>';

            if (cellValue instanceof Array) {
              editableCellTemplate = '<div>';
              if (data.fields[i].multiSelect) {
                editableCellTemplate += '<a data-cell-input="multiSelect" data-ng-model="modalWatcher">Select Values</a>';
              }else{
                editableCellTemplate += '<select data-cell-input data-ng-model="COL_FIELD" data-ng-options="field as field for field in usersAssign.assignedUsersModel[ row.rowIndex ][\'id_'+data.fields[i].fieldOrder+'\']">';
                editableCellTemplate += '<option value="">Select One</option>';
                editableCellTemplate += '</select>';
              }
              editableCellTemplate += '</div>';
            }else{
              editableCellTemplate = '<div>';
              editableCellTemplate += '<input data-cell-input data-ng-model="COL_FIELD" />';
              editableCellTemplate += '</div>';
            }

            //this.sortInfo.fields.push('id_'+data.fields[i].fieldOrder);
            this.assignmentFields.push({
              field: 'id_'+data.fields[i].fieldOrder,
              displayName: data.fields[i].name,
              editableCellTemplate: editableCellTemplate,
              cellTemplate: cellTemplate
            });
          }

          this.assignmentColumns = this.assignmentColumns.concat(this.assignmentFields.slice(0));

        }

        this.resourceTemplates[data.id] = data;

      },

      updateUnassignedUsers: function() {
        var i, ii,
            j, jj,
            unassigned,
            unassignedUsers = [];

        for (i=0,ii=this.usersModel.length;i<ii;i++) {
          unassigned = true;
          for (j=0,jj=this.assignedUsersModel.length;j<jj;j++) {
            if (parseInt(this.usersModel[i].id, 10) === parseInt(this.assignedUsersModel[j].id, 10)) {
              unassigned = false;
              console.log('UsersAssignController::updateUnassignedUsers -> unassigned', this.usersModel[i].id, this.assignedUsersModel[j].id);
              break;
            }
          }

          if (unassigned) {
            unassignedUsers.push(this.usersModel[i]);
          }

        }
        console.log('UsersAssignController::updateUnassignedUsers', this.usersModel, unassignedUsers);
        this.unassignedUsersModel = unassignedUsers;
      },

      assign: function() {

        var i, ii,
            data = {
              resourceTemplateId: this.selectedResourceTemplateId,
              entityIds: []
            };

        for (i=0,ii=this.selectedUnassignedUsers.length;i<ii;i++) {
          data.entityIds.push(this.selectedUnassignedUsers[i].id);
        }

        console.log('UsersAssignController::assign', data);
        ApiService.resource.instances.batchCreate(data).then(this.success.batchCreate, this.error.batchCreate);

      },

      unassign: function() {
        ApiService.resource.instances.remove(this.selectedAssignedUsers).then(this.success.unassign, this.error.unassign);
      },

      update: function() {
        var i, ii;

        for (i=0,ii=this.updateCache.length;i<ii;i++) {
          ApiService.resource.instances.update(this.model[this.updateCache[i]]).then(this.success.update, this.error.update);
        }

      },

      success: {
        initResources: function(response) {
          $scope.usersAssign.getUsers();
        },

        batchCreate: function(response) {
          console.log('UsersAssignController::success::batchCreate', response.payload);
          $scope.unassignedUsersGridOptions.selectAll(false);
          $scope.usersAssign.initResources($scope.usersAssign.selectedResourceTemplateId);
        },

        unassign: function(response) {

        },

        update: function(response) {
          $scope.usersAssign.updateCache = [];
          $scope.usersAssign.isUpdated = true;
        },

        getUsers: function(response) {
          $scope.usersAssign.unassignedUsersModel = response.data.payload;
          $scope.usersAssign.usersModel = response.data.payload;
        },

        getUnassignedUsers: function(response) {
          $scope.usersAssign.unassignedUsersModel = response.data.payload;
        },

        getAssignedUsers: function(response) {
          console.log('UsersAssignController::getAssignedUsers');
          $scope.usersAssign.assignedUsersModel = $scope.usersAssign.processUsers(response.data.payload);
          $scope.usersAssign.updateUnassignedUsers();

        },

        getResourceTemplates: function(response, status, headers, config) {
          $scope.usersAssign.summariesLoading = false;
          $scope.usersAssign.resourcesSummaries = response.data.summaries;
          $scope.usersAssign.selectResource($scope.usersAssign.resourcesSummaries[0]);
        },

        getResourceTemplate: function(response) {
          $scope.usersAssign.updateAssignmentColumns(response.data.resourceType);
        }
      },

      error: {

        initResources: function(response) {},

        batchCreate: function(response) {

        },

        getUsers: function(response) {

        },

        update: function(response) {

        },

        getUnassignedUsers: function(response) {

        },

        getAssignedUsers: function(response) {

        },

        getResourceTemplates: function(response, status, headers, config) {
          $scope.usersAssign.summariesLoading = false;
        },

        getResourceTemplate: function(response) {

        }
      },

      onDestroy: function() {
        $scope.$emit('Application::viewChange', { view: 'sidebar' });
      },

      cellInputEditStartModal: function(e, data) {
        console.log('UsersAssignController::cellInputEditStartModal', data);
        var self = $scope.usersAssign;

        self.multiSelectModal = $uibModal.open({
          templateUrl: 'common/includes/multiSelectModal.tpl.html',
          controller: ['$scope', '$uibModalInstance', 'ValidateService', 'NoticeFactory', function($scope, $uibModalInstance, ValidateService, NoticeFactory) {

            var i, ii,
                selected = false;

            // Populate possible values to the model for use in modal
            $scope.model = [];

            $scope.errors = [];

            $scope.fieldName = data.column.displayName;

            // Assign field values need selected in modal

            for (i=0,ii=self.assignedUsersModel[data.rowIndex][data.column.field].length;i<ii;i++) {
              if (self.editedAssignedUsers[data.rowIndex][data.column.field]) {
                // See if field value is selected
                if (self.editedAssignedUsers[data.rowIndex][data.column.field] instanceof Array) {
                  selected = (self.editedAssignedUsers[data.rowIndex][data.column.field].indexOf(self.assignedUsersModel[data.rowIndex][data.column.field][i]) !== -1);
                }
              }
              console.log('UsersAssignController::cellInputEditStartModal -> selected', self.assignedUsersModel[data.rowIndex][data.column.field][i], selected);
              $scope.model.push({
                name: self.assignedUsersModel[data.rowIndex][data.column.field][i],
                selected: selected
              });
            }

            $scope.hasErrors = function() {
              return ($scope.errors.length > 0);
            };

            $scope.done = function () {
              $uibModalInstance.close($scope.model);
            };

            $scope.cancel = function () {
              $uibModalInstance.dismiss('cancel');
            };

            $scope.success = function(response) {
              $uibModalInstance.close(response);
            };

          }]
        });

        // Invoked when modal completes with close(params)
        self.multiSelectModal.result.then(function (values) {

          var i, ii,
              fieldValues = [];

          for (i=0,ii=values.length;i<ii;i++) {
            if (values[i].selected) {
              fieldValues.push(values[i].name);
            }
          }

          self.editedAssignedUsers[data.rowIndex][data.column.field] = fieldValues;
          $scope.$broadcast('cellInputEdit', {
            rowIndex: data.rowIndex
          });

          console.log('UsersAssignController::cellInputEditStartModal::multiSelectModal::success', data.column.field, fieldValues, self.editedAssignedUsers);
        }, function () {
          // Do nothing
        });
      },

      onCellInputEdit: function(e, data) {
        var i, ii,
            self = $scope.usersAssign;

        console.log('UsersAssignController::onCellInputEdit -> data', data);

        for (i=0,ii=self.model[data.rowIndex].fields.length;i<ii;i++) {
          // Reassign single value to field type value
          var fieldTypes = HelpersService.getFieldType(self.model[data.rowIndex].fields[i]),
              fieldKey = fieldTypes.simpleType + 'Value',
              fieldType = fieldTypes.simpleType + 'Type',
              altFieldKey = fieldTypes.simpleType + 'ArrayValue';

          if (self.model[data.rowIndex].fields[i].multiSelect) {
            // multiSelect fields are arrays so update the type
            fieldType = fieldTypes.simpleType + 'ArrayType';
            fieldKey = fieldTypes.simpleType + 'ArrayValue';
            altFieldKey = fieldTypes.simpleType + 'Value';
          }

          self.model[data.rowIndex].fields[i].type = HelpersService.cap(fieldType);
          self.model[data.rowIndex].fields[i][fieldKey] = self.editedAssignedUsers[data.rowIndex]['id_'+self.model[data.rowIndex].fields[i].fieldOrder];
          self.model[data.rowIndex].fields[i][altFieldKey] = null;
        }

        if (self.updateCache.indexOf(data.rowIndex) === -1) {
          self.updateCache.push(data.rowIndex);
        }

        console.log('UsersAssignController::onCellInputEdit -> model', self.model);
      }

    };

    $scope.assignedUsersGridOptions = {
      enableCellEdit: true,
      enableCellEditOnFocus: true,
      paginate: false,
      enableRowSelection: true,
      multiselect: true
    };

    $scope.unassignedUsersGridOptions = {
      paginate: false,
      enableRowSelection: true,
      multiselect: true,
      columnDefs: [
        {
          field: 'firstName',
          displayName: 'FirstName',
          cellTemplate: $scope.gridLink
        },
        {
          field: 'lastName',
          displayName: 'Last Name',
          cellTemplate: $scope.gridLink
        },
        {
          field: 'email',
          displayName: 'Email',
          cellTemplate: $scope.gridLink
        },
        {
          field: 'phoneNumber',
          displayName: 'Phone Number'
        },
        {
          field: 'title',
          displayName: 'Job Title'
        },
        {
          field: 'confirmed',
          displayName: 'Activated'
        },
        {
          field: 'onBoarded',
          displayName: 'Registered'
        }
      ]
    };



    $scope.usersAssign.init();

}]);